import { useState } from "react";
import "./StarRating.scss";

export default function StarRating({ value, onChange, max = 5 }) {
    const [hover, setHover] = useState(null);

    const getFillClass = (index) => {
        const rating = hover ?? value;
        if (rating >= index + 1) return "full";
        if (rating >= index + 0.5) return "half";
        return "empty";
    };

    const getRatingFromEvent = (e, index) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const isLeftHalf = (e.clientX - rect.left) < rect.width / 2;
        return index + (isLeftHalf ? 0.5 : 1);
    };

    return (
        <div className="star-rating">
            {[...Array(max)].map((_, index) => (
                <div
                    key={index}
                    className={`star-wrapper ${getFillClass(index)}`}
                    onMouseMove={(e) => setHover(getRatingFromEvent(e, index))}
                    onMouseLeave={() => setHover(null)}
                    onClick={(e) => {
                        const rating = getRatingFromEvent(e, index);
                        onChange(rating);      // ⭐ correct value saved!
                    }}
                >

                    <svg className="star" viewBox="0 0 24 24">
                        <defs>
                            {/* Full gold metallic */}
                            <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#fff7cc" />
                                <stop offset="20%" stopColor="#ffe27d" />
                                <stop offset="45%" stopColor="#ffd23c" />
                                <stop offset="60%" stopColor="#ffbf00" />
                                <stop offset="80%" stopColor="#d4a017" />
                                <stop offset="100%" stopColor="#b8860b" />
                            </linearGradient>

                            {/* Half star fill */}
                            <linearGradient id="halfGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                {/* Left half — gold */}
                                <stop offset="0%" stopColor="#ffd700" />
                                <stop offset="50%" stopColor="#ffd700" />

                                {/* Right half — transparent */}
                                <stop offset="50%" stopColor="transparent" />
                                <stop offset="100%" stopColor="transparent" />
                            </linearGradient>
                        </defs>

                        <path d="M12 .587l3.668 7.568L24 9.748l-6 5.848L19.336 24 
            12 20.013 4.664 24 6 15.596 0 9.748l8.332-1.593z" />
                    </svg>



                    <div className="star-glow"></div>

                </div>
            ))}
        </div>
    );
}
